// @flow
import React from "react";

export default function starRating(rate: number, totalCount?: number) {
  const count = totalCount ? totalCount : 5;
  let content = [];

  for (let i = 0; i < count; i++) {
    const name = i < Math.round(rate) ? "star_rate" : "star_border";
    content.push(<span className="material-icons pointer">{name}</span>);
  }

  return <div className="d-flex">{content}</div>;
}
